import useStore from '../useStore';

const useTypeStore = (storeName, storeType) => {
  const store = useStore();

  return store[storeName];
};

export default useTypeStore;
